import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import { CircularProgress, Paper } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: 24,
        textDecoration: 'none',
        background: '#fff',
        borderRadius: 28,
        border: '1px solid #EEEEEE',
        height: 92,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: '0px 10px 40px rgba(186, 184, 176, 0.2)'
        }
    },
    value: {
        fontSize: 32,
        fontWeight: 800,
        marginBottom: 10,
        color: '#F5736A'
    },
    text: {
        fontSize: 14,
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        color: '#888',
        '& div': {
            width: 14,
            color: theme.palette.primary.main
        }
    }
}));

const Counter = ({ data, loading, customClasses }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();

    return (
        <Paper
            elevation={0}
            className={cx(classes.root, customClasses.root)}
            onClick={() => history.push('/search?query=' + data.key)}
        >
            <div className={cx(classes.value, customClasses.value)}>
                {loading ? <CircularProgress size={32} /> : data.value}
            </div>

            <div className={classes.text}>
                <span>{data.text}</span>
            </div>
        </Paper>
    );
};

Counter.propTypes = {
    loading: PropTypes.bool,
    customClasses: PropTypes.shape({
        root: PropTypes.string,
        value: PropTypes.string
    }),
    data: PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.any,
        text: PropTypes.string
    })
};

Counter.defaultProps = {
    customClasses: {},
    data: {}
};

export default Counter;
